import { Injectable } from '@angular/core';
import { GlobalDomOpsService, CommonOperationsService, GlobalDataOpsService, AcepSSOService } from '@acepteam/globalspack';
import { DomService, DataService, HelperService, LoggerService } from '../../core/services';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Summary, GroupPortalData } from '../../shared/models';
import { MemberType } from '../../shared/enums/data.enums';
import { ChapterInfo } from '../../shared/models/chapter-details';


declare var $: any;
declare var moment: any;


@Injectable(
	{
		providedIn: "root"
	}
)
export class GroupPortalDomService {

	constructor(private globalDomOpsService: GlobalDomOpsService, private ssoService: AcepSSOService,
		private domService: DomService,
		private globalDataOpsService: GlobalDataOpsService,
		private dataService: DataService,
		private commonOpsService: CommonOperationsService,
		private helperService: HelperService,
		private titleService: Title,
		private loggerService: LoggerService,
		private http: HttpClient) { }


}
